export const isTreeAdmin = (account, adminRole) => {
	// adminRole comes from checkAdminStatus API or from context
	return adminRole === "SUPER_ADMIN" || adminRole === "ADMIN";
};

export const isTreeSuperAdmin = (account, adminRole) => {
	return adminRole === "SUPER_ADMIN";
};